import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../gen-src/Localize';
import { UserProfilePicture } from '../../userManagement/components/userProfilePicture/UserProfilePicture';

import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { ContentDefinitions } from '../models/ContentDefinitions';
import { QuickLinksViewModel } from '../viewModels/QuickLinksViewModel';
import { activeSectionItem, ownerSection, section, sectionHeaderTitle } from './OmniboxV2Styles';

export const QuickLinksTestId = 'QuickLinks';

export function QuickLinks(props: { viewModel: QuickLinksViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return <div data-tb-test-id={QuickLinksTestId}>
        <div className={[section, 'tb-quicklinks-section-divider'].join(' ')} id='quicklinks-content-section'>
            {renderHeader(Messages.contentType())}
            <div className='tb-quicklinks-row'>{renderContentTypes()}</div>
        </div>
        {
            viewModel.shouldShowOwnerList() ? <div className={[section, ownerSection, ((!viewModel.areOwnersLoaded || viewModel.ownerItems.length > 0) ? 'tb-quicklinks-section-divider' : '')].join(' ') + (!viewModel.areOwnersLoaded ? ' tb-loading' : '') + (viewModel.areOwnersLoaded && viewModel.ownerItems.length === 0 ? ' tb-empty' : '')}
                id='quicklinks-owner-section'>
                {
                    viewModel.areOwnersLoaded ?
                        (viewModel.ownerItems.length > 0 ?
                            <>
                                {renderHeader(Messages.owner())}
                                <div className='tb-quicklinks-row'>{renderOwners()}</div>
                            </> :
                            <></>) :
                        <div className='tb-quicklinks-pending-spinner' style={{ height: '134px' }}>
                            <ActivitySpinnerWidget
                                spinnerSize={ActivitySpinnerSize.Small}
                                testId={'omnibox-pending'}
                            />
                        </div>}
            </div>
                : null
        }
    </div>;

    function renderHeader(title: string): JSX.Element {
        return <span className={sectionHeaderTitle}>
            {title}
        </span>;
    }

    function renderContentTypes(): JSX.Element[] {
        return viewModel.contentTypeItems ? viewModel.contentTypeItems.map((item, index) => {
            const contentDefinition = ContentDefinitions[item.contentType];
            return <a id={item.getIdentifier()} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem} key={contentDefinition.getName()} href={item.url}
                className={'tb-quicklinks-highlight' + (item === viewModel.currentKeyboardNavigableItem ? (' ' + activeSectionItem) : '')} onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onContentTypeLinkClicked(item); }}>
                <div key={contentDefinition.getName()} className='tb-quicklinks-highlight-border'>
                    <img src={contentDefinition.icon} alt='' />
                </div>
                <span style={{ display: 'block', marginTop: '6px', fontSize: '12px' }}>{contentDefinition.getName()}</span>
            </a>;
        })
            : null;
    }

    function renderOwners(): JSX.Element[] {
        return viewModel.ownerItems ? viewModel.ownerItems.map((item, index) => {
            return <a id={item.getIdentifier()} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem} key={item.content?.id} href={item.url} className={'tb-quicklinks-highlight' + (item === viewModel.currentKeyboardNavigableItem ? (' ' + activeSectionItem) : '')}
                onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onOwnerItemClicked(item); }} >
                <div key={item.content?.id}>
                    <UserProfilePicture profileDisplayName={item.content?.displayName} imageUrl={item.content?.userImageUrl}
                        imageSize={40} fontSize={16} divStyle={{ marginRight: '8px' }} />
                </div>
                <span style={{ display: 'block', marginTop: '6px', fontSize: '12px' }}>{item.content?.displayName}</span>
            </a>;
        })
            : null;
    }
}